export default __webpack_public_path__ + "static/media/solution_55.08d712ee.svg";